<template>
  <div class="user_maindate">
    <div class="user_maindate_in">

      <section>
        <Table :loading="loading" ref="selection" :columns="columns" :data="Tabledata" @on-selection-change="selection">

          <!-- 是否完成面试 -->
          <template slot-scope="{ row }" slot="is_Complete">
            <i-Switch v-model="row.status" :before-change="()=>handleBeforeChange(row)" />
          </template>
          <template slot-scope="{ row }" slot="details">
            <Button type="primary" size="small" @click="$router.push({name:'interview_manage_detail',query:{id:row.e_resumeId}})">查看</Button>
          </template>
        </Table>
      </section>

      <footer>
        <PageSize :total="pagecount" @page_size="page_size" :page_in="page" :size_in="size" />

        <div>
          <DownloadExcel class="export-excel-wrapper" :data="Selected_arr" :fields="json_fields" name="面试管理.xls">
            <Button size="large" style="background:#FC4455;color:#fff">
              <Icon type="ios-download-outline"></Icon>
              导出数据
            </Button>
          </DownloadExcel>
        </div>
      </footer>

    </div>
  </div>
</template>

<script>
import PageSize from "@/components/PageSize.vue";
export default {
  data() {
    return {
      loading: false,
      page: 1,
      size: 10,
      pagecount: 0,
      Tabledata: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'name',
          render: (h, params) => {
            return h(
              "span",
              params.row.personal ? params.row.personal.name : ''
            )
          },
          align: 'center',
          minWidth: 100,
        },
        {
          title: '性别',
          key: 'sex',
          render: (h, params) => {
            return h(
              "span",
              params.row.personal ? (params.row.personal.sex == 1 ? '男' : '女') : ''
            )
          },
          align: 'center',
          minWidth: 100,
        },

        {
          title: '年龄',
          key: 'age',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '学历',
          key: 'education',
          render: (h, params) => {
            return h(
              "span",
              params.row.personal ? params.row.personal.education : ''
            )
          },
          align: 'center',
          minWidth: 100,
        },
        {
          title: '手机号',
          key: 'phone',
          render: (h, params) => {
            return h(
              "span",
              params.row.personal ? params.row.personal.phone : ''
            )
          },
          align: 'center',
          minWidth: 150,
        },
        {
          title: '投递岗位',
          key: 'positionName',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '面试时间',
          key: 'date',
          align: 'center',
          minWidth: 200,
        },
        {
          title: '是否完成面试',
          align: 'center',
          slot: 'is_Complete',
          minWidth: 200,
        },
        {
          title: '操作',
          slot: 'details',
          width: 140,
          align: 'center',
          width: 100,
        }


      ],
      Selected_arr: [],
      json_fields: {
        "姓名": {
          field: "personal",
          callback: (personal) => {
            return personal.name

          },
        },
        "性别": {
          field: "personal",
          callback: (personal) => {
            return personal.sex == 1 ? '男' : '女'
          },
        },
        "年龄": "age",
        "学历": {
          field: "personal",
          callback: (personal) => {
            return personal.education

          },
        },
        "手机号": {
          field: "personal",
          callback: (personal) => {
            return personal.phone
          },
        },
        "投递岗位": "positionName",
        "面试时间": "date",
        "是否完成面试": {
          field: "status",
          callback: (status) => {
            return status ? '是' : '否'
          },
        },
      },
    }
  },
  components: {
    PageSize,
  },
  methods: {
    //设置是否在职
    handleBeforeChange(row) {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: `您确认变更此人员为${row.status ? '未完成面试' : '已完成面试'}状态吗`,
          onOk: () => {
            console.log(row);
            this.app("enterpriseOperators", "updateInterviewStatus", {
              id: row._id,
              status: row.status ? 260 : 280
            }).then(res => {
              if (res.code == 200) {
                this.$Message.success("修改成功")
                resolve();
              }


            })
          }
        });
      });
    },
    //选中
    selection(arr) {
      this.Selected_arr = arr;
    },
    //获取分页
    page_size(page, size) {
      this.page = page;
      this.size = size;
      this.get_data();
    },
    //封装获取数据
    get_data() {
      this.loading = true
      this.app("enterpriseOperators", "getMyInterViews", {
        mobile: this.mobile,
        page: this.page,
        size: this.size
      }).then(res => {
        console.log(res);
        this.loading = false
        this.pagecount = res.pageSize
        this.Tabledata = res.data
        this.Tabledata.forEach((item, index) => {
          item.status = item.status == 280 ? true : false
        });
        res.data.forEach(row => {
          if (row.personal) {

            // 生日
            var data = row.personal.birthDate;
            // console.log(data);
            if (data == undefined || data == null) {

            } else {
              var birthYear = data[0] + data[1] + data[2] + data[3];
              var y = new Date().getFullYear();
            }

            // 开始工作时间
            var dates = row.personal.workedDate;
            if (dates == undefined || dates == null) {

            } else {
              var workedDate = dates[0] + dates[1] + dates[2] + dates[3];
            }

            var age = y - birthYear + "岁";
            var workYear = y - workedDate + "年";

            row.age = age;
            row.workYear = workYear;
          }

        });
      })
    },









  },
  created() {

    this.mobile = localStorage.getItem("firm_mobile");
    this.app("enterpriseOperators", "getEmployeeMassage", {
      mobile: this.mobile,
    }).then(res => {
      console.log(res);
      if (res.data.enterpriseId) {
        // 保存个人id，职位id到本地
        // localStorage.setItem("emploee_id", res.result.data._id);
        // localStorage.setItem("enterprise_id", res.result.data.enterpriseId);
        // enterprieseId = res.result.data.enterpriseId;

        this.get_data()

      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '企业信息未完善，请先完善信息',
          onOk: () => {
            // this.$router.push({name:''})

          }
        });
      }
    })
  }


}
</script>

<style lang="less" scoped>
.user_maindate {
  color: #000000;
  font-size: 18px;
  background: #f5f7f9;
  padding: 18px 24px;

  .user_maindate_in {
    background: #fff;
    padding: 16px 31px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 36px;
      margin-bottom: 16px;
      .left {
        display: flex;
        align-items: center;
        .top_item {
          display: flex;
          align-content: center;
          margin-right: 48px;
          p {
            display: flex;
            align-items: center;
          }
        }
      }
    }

    footer {
      padding-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>